import { render, staticRenderFns } from "./RemoteAddress.vue?vue&type=template&id=2d630710&"
import script from "./RemoteAddress.vue?vue&type=script&lang=js&"
export * from "./RemoteAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d630710')) {
      api.createRecord('2d630710', component.options)
    } else {
      api.reload('2d630710', component.options)
    }
    module.hot.accept("./RemoteAddress.vue?vue&type=template&id=2d630710&", function () {
      api.rerender('2d630710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/forms/RemoteAddress.vue"
export default component.exports